import { landingPages } from "@/data/landingPages.data";

// Every registered data-driven landing page (see `src/data/landingPages.data.ts`,
// rendered by `<LandingPage>`) opens with the dark Website 2.0
// <PageHero> (`bg-secondary-2`) - so its header/footer must always match that,
// and a newly added page gets it for free without anyone having to remember
// to edit this file.
const registeredLandingPageBg = Object.fromEntries(
  Object.keys(landingPages).map((slug) => [`/${slug}`, "bg-secondary-2"]),
);

export const heroBackgrounds: Record<string, string> = {
  "/": "bg-secondary-2", // Merchants
  "/landing": "bg-secondary-2",
  "/pricing": "default",
  "/contact": "bg-primary",
  "/customers": "bg-primary",
  "/checkout": "default",
  "/about-us": "default",
  "/blogs": "bg-primary",
  "/blogs/slug": "default",
  "/terms-and-conditions": "default",
  "/privacy-policy": "default",
  "/refund-policy": "default",
  "/get-started-for-free": "",
  "/referral": "bg-secondary-2",
  "/download-now": "default",
  "/partner-signup": "bg-primary",
  "/partner-signup/status": "default",
  "/customer-loyalty-platform": "bg-secondary-2",
  "/free-customer-loyalty-app": "bg-secondary-2",
  "/customer-retention-platform-india": "bg-secondary-2",
  "/loyalty-software-for-shop-owners": "bg-secondary-2",
  "/retail-customer-engagement-platform": "bg-secondary-2",
  "/whatsapp-marketing-for-retail-business": "bg-secondary-2",
  "/loyalty-program-for-retail-stores": "bg-secondary-2",
  "/loyalty-program-software-for-retail": "bg-secondary-2",
  "/customer-analytics-for-retail": "bg-secondary-2",
  "/cashback-and-rewards-system-for-shops": "bg-secondary-2",
  "/how-to-increase-repeat-customers": "bg-secondary-2",
  "/how-to-bring-customers-back-to-shop": "bg-secondary-2",
  "/increase-footfall-in-retail-store": "bg-secondary-2",
  "/customer-retention-strategies-for-small-business": "bg-secondary-2",
  "/loyalty-program-for-grocery-store": "bg-secondary-2",
  "/loyalty-app-for-clothing-store": "bg-secondary-2",
  "/customer-retention-for-restaurants": "bg-secondary-2",
  "/loyalty-software-for-salon": "bg-secondary-2",
  ...registeredLandingPageBg,
  // Website 2.0 pages: dark hero like the landing pages (PageHero/Breadcrumbs).
  "/tiered-loyalty-program": "bg-secondary-2",
  "/loyalty-membership-program": "bg-secondary-2",
  "/tailored-loyalty-solutions": "bg-secondary-2",
  "/spin-the-wheel-loyalty": "bg-secondary-2",
  "/scratch-and-win-loyalty": "bg-secondary-2",
  "/customer-loyalty-program": "bg-secondary-2",
  "/discount-loyalty-program": "bg-secondary-2",
  "/whatsapp-loyalty-marketing": "bg-secondary-2",
  "/qr-code-loyalty-program": "bg-secondary-2",
  "/referral-rewards-software": "bg-secondary-2",
  "/customer-engagement-campaigns": "bg-secondary-2",
  "/customer-win-back-software": "bg-secondary-2",
  "/cashback-loyalty-program": "bg-secondary-2",
  "/loyalty-points-software": "bg-secondary-2",
  "/guides": "bg-secondary-2",
  "/how-to-plan-a-loyalty-program": "bg-secondary-2",
  "/how-to-record-a-bill-with-fydo": "bg-secondary-2",
  "/how-to-read-your-customer-data": "bg-secondary-2",
  "/how-to-segment-customers": "bg-secondary-2",
  "/how-to-create-a-whatsapp-campaign": "bg-secondary-2",
  "/how-to-increase-repeat-purchases": "bg-secondary-2",
  "/loyalty-program-for-spas": "bg-secondary-2",
  "/loyalty-program-for-gyms": "bg-secondary-2",
  "/loyalty-program-for-yoga-studios": "bg-secondary-2",
  "/loyalty-program-for-fitness-studios": "bg-secondary-2",
  "/loyalty-program-for-ecommerce": "bg-secondary-2",
  "/loyalty-program-for-b2b-ecommerce": "bg-secondary-2",
  "/loyalty-program-for-manufacturing": "bg-secondary-2",
  "/loyalty-program-for-consumer-brands": "bg-secondary-2",
  "/loyalty-program-for-enterprise": "bg-secondary-2",
  "/loyalty-program-for-multi-location-businesses": "bg-secondary-2",
  "/resources": "bg-secondary-2",
  "/faqs": "bg-secondary-2",
  "/case-studies": "bg-secondary-2",
  "/customer-stories": "bg-secondary-2",
  "/documentation": "bg-secondary-2",
  "/careers": "bg-secondary-2",
  "/industry-insights": "bg-secondary-2",
  "/loyalty-program-for-jewellery-store": "bg-secondary-2",
  "/pos-loyalty-integration": "bg-secondary-2",
  "/products": "bg-secondary-2",
  "/products/loyalty-programs": "bg-secondary-2",
  "/products/marketing-campaigns": "bg-secondary-2",
  "/products/customer-intelligence": "bg-secondary-2",
  "/solutions": "bg-secondary-2",
  "/solutions/ecommerce-d2c": "bg-secondary-2",
  "/solutions/consumer-brands-manufacturing": "bg-secondary-2",
  "/solutions/enterprise-multi-location": "bg-secondary-2",
  "/solutions/franchise-loyalty": "bg-secondary-2",
};

export const footerBackgrounds2: Record<string, string> = {
  "/": "bg-secondary-2", // Merchants
  "/pricing": "bg-secondary-2",
  "/contact": "bg-primary",
  "/customers": "bg-primary",
  "/about-us": "bg-primary",
  "/blogs": "bg-primary",
  "/get-started-for-free": "",
  "/customer-loyalty-platform": "bg-secondary-2",
  "/free-customer-loyalty-app": "bg-secondary-2",
  "/customer-retention-platform-india": "bg-secondary-2",
  "/loyalty-software-for-shop-owners": "bg-secondary-2",
  "/retail-customer-engagement-platform": "bg-secondary-2",
  "/whatsapp-marketing-for-retail-business": "bg-secondary-2",
  "/loyalty-program-for-retail-stores": "bg-secondary-2",
  "/loyalty-program-software-for-retail": "bg-secondary-2",
  "/customer-analytics-for-retail": "bg-secondary-2",
  "/cashback-and-rewards-system-for-shops": "bg-secondary-2",
  "/how-to-increase-repeat-customers": "bg-secondary-2",
  "/how-to-bring-customers-back-to-shop": "bg-secondary-2",
  "/increase-footfall-in-retail-store": "bg-secondary-2",
  "/customer-retention-strategies-for-small-business": "bg-secondary-2",
  "/loyalty-program-for-grocery-store": "bg-secondary-2",
  "/loyalty-app-for-clothing-store": "bg-secondary-2",
  "/customer-retention-for-restaurants": "bg-secondary-2",
  "/loyalty-software-for-salon": "bg-secondary-2",
  ...registeredLandingPageBg,
};

// The footer's background for a route - red (`bg-primary`) unless the route
// is listed in footerBackgrounds2. Shared with the closing CTA band so the
// two can never drift apart.
export function getFooterBackground(pathname: string): string {
  return footerBackgrounds2[pathname] || "bg-primary";
}

// The closing CTA band (SignupSection, via FinalCta) always contrasts with
// the footer right below it: dark band above a red footer, red band above a
// dark one.
export function getClosingBandBackground(
  pathname: string,
): "bg-primary" | "bg-secondary-2" {
  return getFooterBackground(pathname) === "bg-primary"
    ? "bg-secondary-2"
    : "bg-primary";
}
